import { SpecialInfoTypes } from '@booking/constants/special-info-types';

import { CASHBACK_TRAVEL } from '../country-assets/CO/cashback';
import { CHUBB_TERMS } from '../country-assets/CO/chubb-co';
import { DAVIVIENDA } from '../country-assets/CO/davivienda-co';
import { HOW_RENT } from '../country-assets/CO/rent';
import { CIVITATIS_TERMS } from '../es-assets/civitatis-es';

export const AssetTermBase = {
  BLACK_FRIDAY: null,
  BLACK_WEEKEND: null,
  CASHBACK_TRAVEL: CASHBACK_TRAVEL,
  HOW_RENT: HOW_RENT,
  CHUBB_TERMS: CHUBB_TERMS,
  CIVITATIS_TERMS: CIVITATIS_TERMS,
  CASHBACK_30_TRAVEL: null,
  CASHBACK_HOTEL_CARS: null,
  ELO_TRAVEL: null,
  GYRA_TRAVESIA: null,
  HOTELS_OFF_TRAVEL: null,
  INSTALLMENTS: null,
  LIVELO_TRAVEL: null,
  PONTOS_DOTZ_TRAVEL: null,
  PREVIAJE_II: null,
  RAPPICARD_TERMS: null,
  TUDO_AZUL_TRAVEL: null,
  DAVIVIENDA: DAVIVIENDA,
  RAPPI_TRAVEL: null,
  HOTELS_5_PER: null,
  DUTY_FREE: null,
  SUMMARY_TERMS_AND_POLICIES: {
    INDIVIDUAL_TERMS: true,
    CAMPAIGNS_TERMS_IN_FOOTER: false,
    INITIAL_TEXT: 'Leí y acepto',
    FINAL_TEXT: 'de Travel Moustache.',
    TERMS_AND_CONDITIONS: {
      INITIAL_TEXT: 'los',
      ALTERNATIVE_TEXT: 'y los',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['terms'] } }],
        TEXT: 'Términos y Condiciones',
        STATE: {}
      },
    },
    TREATMENT_PERSONAL_POLICIES: {
      INITIAL_TEXT: 'el',
      ALTERNATIVE_TEXT: '',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['treatment-personal-data'] } }],
        TEXT: 'Tratamiento de datos personales',
        STATE: {}
      }
    },
    PRIVACY_POLICIES: {
      INITIAL_TEXT: 'y la',
      ALTERNATIVE_TEXT: 'la',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['private-policy'] } }],
        TEXT: 'Política de Privacidad',
        STATE: {}
      }
    },
    CIVITATIS_POLICIES: {
      INITIAL_TEXT: 'los',
      ALTERNATIVE_TEXT: 'de Civitatis.',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
        TEXT: 'Términos y Condiciones',
        STATE: {
          infoType: SpecialInfoTypes.CIVITATIS
        }
      }
    },
    CAMPAIGNS_TERMS: [
      {
        DISABLED: true,
        INITIAL_TEXT: 'los',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Términos y Condiciones de CHUBB Seguros',
          STATE: { infoType: SpecialInfoTypes.CHUBB }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: 'los',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Términos y Condiciones pagando en Travel con Davivienda',
          STATE: { infoType: SpecialInfoTypes.DAVIVIENDA }
        }
      },
    ]
  }
};
